import { Navigate } from 'react-router-dom';
import useAuth from './useAuth';

export default function PublicRoute({ children }) {
  const { token, user, isLoadingUser } = useAuth();

  // wait until user is resolved
  if (isLoadingUser) return null; // or loader

  // "/" rather than /dashboard, so HomeRedirect works out where this person
  // belongs. Someone already signed in who opens the login page should land
  // where their app begins, which is not the dashboard for every role.
  if (token && user) {
    return <Navigate to="/" replace />;
  }

  return children;
}
